import { primaryColors } from './primaryColors';

export const colors = {
  // Main Colors
  black: '#000000',
  white: '#ffffff',

  ...primaryColors,
};
